import { render, staticRenderFns } from "./ArticleCreationPage.vue?vue&type=template&id=57565155&scoped=true&"
import script from "./ArticleCreationPage.vue?vue&type=script&lang=js&"
export * from "./ArticleCreationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57565155",
  null
  
)

export default component.exports